var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2048 2048",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4.16518,-12.6347)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-168,72)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1196.16,
    cy: 964.635,
    r: 779,
    style: {
      fillOpacity: 0.82
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.16518,12.6347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1024,271.459C1439.34,271.459 1776.54,608.662 1776.54,1024C1776.54,1439.34 1439.34,1776.54 1024,1776.54C608.662,1776.54 271.459,1439.34 271.459,1024C271.459,608.662 608.662,271.459 1024,271.459ZM1486.19,1021.73L723.373,1369.14L723.373,674.323L1486.19,1021.73Z",
    style: {
      fill: "rgb(100,255,177)"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.0b1ec00831fe42f20e6501ef50e1353c.svg";
export { ForwardRef as ReactComponent };